import React from 'react';
import { Route, Routes } from '@leagueplatform/routing';

// Pages
import { OnboardingLandingPage } from '#pages/onboarding-landing-page/index.tsx';

export const OnboardingRoutes = () => (
  <Routes>
    <Route element={<OnboardingLandingPage />} path="/*" />
  </Routes>
);
